export default __webpack_public_path__ + "static/media/ease-of-use.d28a6d4c.svg";